<template>
  <section id="top" class="top">

    <!-- 背景動画 -->
    <div class="bg-video">
      <video class="hero-video" src="/videos/top-main.mp4"
        poster="~/assets/pages/top/MoodImagePoster.webp"
        autoplay
        loop
        muted
        playsinline
      />
    </div>

    <div class="top-content">
      <!-- ロゴ -->
      <div class="card-container">
        <img class="logo" src="~/assets/pages/common/Logo_White.svg" :alt="$t('util.title')" />
        <div class="sub-title-text">
          {{ $t('util.title_and_sub_title') }}
        </div>
      </div>

      <!-- キャッチコピー -->
      <div class="catch-copy" :class="localeClass">
        <div class="text-1" v-html="$t('page.top.text-1')"></div>
        <div class="text-2" v-html="$t('page.top.text-2')"></div>
      </div>

      <!-- 言語セレクタ -->
      <LangSelect class="lang-select" />
    </div>
  </section>
</template>
<script setup lang="ts">
const { locale } = useI18n()
const localeClass = computed(() => `-${locale.value}`)
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#top {
  width: 100%;
  height: calc(100svh - 80px);
  position: relative;
  /* text-align: center; */
}

.bg-video {
  position: relative;
  width: 100%;
  height: calc(100svh - 80px);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .hero-video {
    background: url("~/assets/pages/top/MoodImagePoster.webp") center / cover no-repeat;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: v.$zindex-background;
  }
}

.top-content {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  .card-container {
    position: absolute;
    left: 7%;
    bottom: 5%;
    width: min(calc(130px + 6.354vw), 23.333vh);
    max-width: 200px;
    height: auto;
    box-sizing: border-box;
    text-align: center;
    @include m.sp() {
      width: 32vw;
      max-width: 120px;
    }
  }

  .logo {
    width: 100%;
    height: auto;
    /* キャッチ部は意図せず選択状態にならないようにする */
    pointer-events: none;
    user-select: none;

    @include m.sp() {
      bottom: 12%;
      left: 10%;
      /* width: 36%; */
      width: 100%;
      height: auto;
    }
  }

  .sub-title-text {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    margin: 10% 0;
    font-size: clamp(10px, min(calc((18 / 1920) * 100vw), calc((18 / 1080) * 100vh)), 18px);
    white-space: nowrap;

    color: v.$text-white-color;
    /* キャッチ部は意図せず選択状態にならないようにする */
    pointer-events: none;
    @include m.sp() {
      bottom: 8%;
      left: 9%;
      font-size: clamp(6px, min(calc((9 / 375) * 100vw), calc((9 / 667) * 100vh)), 10px);
    }
  }

  .catch-copy {
    position: absolute;
    writing-mode: vertical-rl;
    font-size: clamp(0.8rem, calc(7vh - 15px), 2rem);
    letter-spacing: 0.59rem;
    line-height: 2;
    right: 12%;
    /* キャッチ部は意図せず選択状態にならないようにする */
    pointer-events: none;
    user-select: none;

    .text-1 {
      color: v.$text-white-color;
      margin-top: clamp(15px, calc(20vh - 100px), 120px);
    }
    .text-2 {
      color: v.$text-white-color;
      margin-top: clamp(15px, calc(40vh - 150px), 40vh);
    }

    @include m.sp() {
      font-size: clamp(0.1rem, calc(1vh + 2vw + 8px), 2rem);
      top:10%;
      .text-1 {
        color: v.$text-white-color;
        margin-top: clamp(15px, calc(20vh - 150px), 520px);
      }
      .text-2 {
        color: v.$text-white-color;
        margin-top: clamp(15px, calc(80vh - 450px), 500px);
      }
    }

    &.-en {
      letter-spacing: 0;
      writing-mode: initial;
      max-width: 80%;
      word-break: keep-all;
      text-align: right;
      font-size: clamp(0.1rem, calc(2.5vh + 2vw - 7px), 2rem);
      bottom: 9%;

      @include m.sp() {
        top: auto;
        bottom: 7%;
        right: 8%;
        max-width: 50vw;
        font-size: clamp(0.1rem, 4vw, 1.2rem);
      }
    }
  }

  .lang-select {
    position: absolute;
    right: 8px;
    bottom: 86px;

    @include m.partSP() {
      position: fixed;
      right: 0;
      bottom: initial;
      z-index: 500;
    }
  }
}

/* 英語版の改行位置調整用 */
:deep(.br-small) {
  display: block;
}
:deep(.br-large) {
  display: none;
}

@media (min-width: 900px) {
  :deep(.br-small) {
    display: none;
  }
:deep(.br-large) {
    display: block;
  }
}

@media (min-width: 1380px) {
  :deep(.br-large) {
    display: none;
  }
}
</style>
